import { MutationTree } from 'vuex';
import { AuthenticationState, initialState } from '@/store/modules/authentication';
import {
  AUTHENTICATION_RESET_STATE,
  SET_AUTH_ERRORS,
  SET_AUTH_LOADING_MODE,
  SET_GOV,
  SET_IS_RECAPTCHA_V2_USED,
  SET_LAST_SSO_USED_TOKEN,
  SET_OIDC_ID,
  SET_OIDC_USER_MANAGER,
  SET_OTP_SENT,
  SET_SELECT_AUTH_METHOD_ERRORS,
  SET_SMS_SENDING,
  SET_USER_DETAILS,
} from '@/types/authentication.types';
import { UserDetails } from '@/models/UserDetails.model';
import { SmsSendingStatus } from '@/models/SmsSendingStatus';
import { SET_INDEX_AND_OFFICES_LIST, SET_UPLOAD_FILE_ENABLE } from '@/types/lobby.types';
import { IndexAndOfficesRequest } from '@/models/request/index-and-offices-request';
import { OidcUserManager } from '@/models/OidcUserManager.model';

export const mutations: MutationTree<AuthenticationState> = {

    [SET_AUTH_LOADING_MODE]: (state, loadingMode: boolean) => {
        state.authLoadingMode = loadingMode;
    },

    [SET_AUTH_ERRORS]: (state, authErrors: string[]) => {
        state.authErrors = authErrors;
    },

    [SET_OTP_SENT]: (state, otpSent: boolean) => {
        state.otpSent = otpSent;
    },

    [SET_SMS_SENDING]: (state, smsSending: SmsSendingStatus) => {
        state.smsSending = smsSending;
    },

    [SET_GOV]: (state, gov: string) => {
        state.gov = gov;
    },

    [SET_LAST_SSO_USED_TOKEN]: (state, token: string) => {
        state.lastSsoUsedToken = token;
    },

    [SET_SELECT_AUTH_METHOD_ERRORS]: (state, selectAuthMethodErrors: string[]) => {
        state.selectAuthMethodErrors = selectAuthMethodErrors;
    },

    [SET_USER_DETAILS]: (state, userDetails: UserDetails) => {
        state.userDetails = { ...state.userDetails, ...userDetails };
    },

    [SET_IS_RECAPTCHA_V2_USED]: (state, isRecaptchaV2Used: boolean) => {
        state.isRecaptchaV2Used = isRecaptchaV2Used;
    },

    [SET_INDEX_AND_OFFICES_LIST]: (state, indexAndOfficesList: IndexAndOfficesRequest[]) => {
        state.indexAndOfficesList = indexAndOfficesList;
    },

    [AUTHENTICATION_RESET_STATE]: (state) => {
        state = Object.assign(state, initialState());
    },

    [SET_UPLOAD_FILE_ENABLE]: (state, uploadFileEnable: boolean) => {
        state.uploadFileEnable = uploadFileEnable;
    },

    [SET_OIDC_ID]: (state, oidcId: string) => {
        state.oidcId = oidcId;
    },

  [SET_OIDC_USER_MANAGER]: (state, userManager: OidcUserManager) => {
    state.oidcUserManager = userManager;
  },

};
